"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSortArrow = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.StyledSortArrow = (0, styled_1.default)('span') `
  position: relative;
  top: 2px;
  margin-left: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  margin-right: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
`;
//# sourceMappingURL=SortArrow.styles.js.map